
  var _styles = {
  "hot-city-image-container": {
    "width": "4.58667rem",
    "height": "3.6rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden",
    "marginBottom": "0.24rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "relative"
  },
  "hot-city-image": {
    "height": "3.57333rem",
    "marginBottom": "0.01333rem",
    "marginLeft": "0.01333rem",
    "marginRight": "0.01333rem",
    "width": "4.56rem",
    "borderRadius": "0.29333rem"
  },
  "hot-city-image-footer": {
    "width": "4.56rem",
    "height": "1.28rem",
    "position": "absolute",
    "left": "0.01333rem",
    "bottom": "0.01333rem",
    "right": "0.01333rem"
  },
  "hot-city-image-footer-gradient": {
    "position": "absolute",
    "width": "100%",
    "height": "100%",
    "borderBottomLeftRadius": "0.29333rem",
    "borderBottomRightRadius": "0.29333rem"
  },
  "hot-city-image-footer-content": {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "paddingTop": "0.26667rem",
    "paddingRight": "0.2rem",
    "paddingBottom": 0,
    "paddingLeft": "0.2rem",
    "flexDirection": "column"
  },
  "hot-city-image-footer-name-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "hot-city-image-footer-name": {
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)"
  },
  "hot-city-image-footer-price": {
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)"
  },
  "hot-city-duration": {
    "fontSize": "0.24rem",
    "textAlign": "right",
    "marginTop": "-0.05333rem",
    "color": "rgb(255,255,255)"
  },
  "hot-city-image-corner": {
    "position": "absolute",
    "top": 0,
    "left": "0.01333rem",
    "borderBottomRightRadius": "0.29333rem",
    "borderTopLeftRadius": "0.29333rem"
  },
  "hot-city-image-corner-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "marginTop": 0,
    "marginRight": "0.13333rem",
    "marginBottom": 0,
    "marginLeft": "0.13333rem"
  }
};



  module.exports = _styles;
  